import { render } from "./CustomerLabels.vue?vue&type=template&id=5fb7113d&scoped=true"
import script from "./CustomerLabels.vue?vue&type=script&lang=js"
export * from "./CustomerLabels.vue?vue&type=script&lang=js"

import "./CustomerLabels.vue?vue&type=style&index=0&id=5fb7113d&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb7113d"]])

export default __exports__